/**
 * Created by linjianxi on 2016/10/27.
 */
export const CHECKSWITCH = 'CHECKSWITCH'
export const GET_RECHARGE_STATUS = 'GET_RECHARGE_STATUS'



// WEBPACK FOOTER //
// ./src/vuex/modules/setting/mutation-type.js